<template>
  <div>
    <el-form :inline="true" :model="query" @keyup.enter.native="load">
      <el-form-item label="科目编码">
        <el-input v-model="query.subjectCode" placeholder="科目编码" size="small" clearable />
      </el-form-item>
      <el-form-item label="科目名称">
        <el-input v-model="query.subjectName" placeholder="科目名称" size="small" clearable />
      </el-form-item>
      <el-form-item label="科目类别">
        <el-select v-model="query.subjectType" placeholder="全部" size="small" clearable>
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('finance:subject:list')" type="primary" size="small" @click="load">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('finance:subject:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="shown"
      border
      row-key="financeSubjectId"
      default-expand-all
      :tree-props="{ children: 'children' }"
      v-loading="loading"
      :header-cell-style="headStyle"
    >
      <el-table-column prop="subjectName" label="科目名称" min-width="220" show-overflow-tooltip>
        <template slot-scope="scope">
          <a v-if="isAuth('finance:subject:info') || isAuth('finance:subject:list')" class="code-link" @click="addOrUpdateHandle(scope.row.financeSubjectId, true)">{{ scope.row.subjectName }}</a>
          <span v-else>{{ scope.row.subjectName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="subjectCode" label="科目编码" width="120" />
      <el-table-column prop="subjectType" label="类别" width="80" align="center">
        <template slot-scope="scope">{{ typeLabel(scope.row.subjectType) }}</template>
      </el-table-column>
      <el-table-column prop="balanceDirection" label="余额方向" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.balanceDirection === '1' ? '借' : '贷' }}</template>
      </el-table-column>
      <el-table-column prop="isLeaf" label="末级" width="70" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isLeaf === '1'" type="success" size="mini">是</el-tag>
          <el-tag v-else type="info" size="mini">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="辅助核算" min-width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.auxCustomer === '1'">客户 </span>
          <span v-if="scope.row.auxSupplier === '1'">供应商 </span>
          <span v-if="scope.row.auxDepartment === '1'">部门 </span>
          <span v-if="scope.row.auxEmployee === '1'">职员</span>
        </template>
      </el-table-column>
      <el-table-column prop="isenabled" label="启用" width="70" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isenabled === '0'" type="success" size="mini">是</el-tag>
          <el-tag v-else type="info" size="mini">否</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />
  </div>
</template>

<script>
import AddOrUpdate from './subject-add-or-update'
import request from '../../api/request'
import auth from './financeAuth'

function toTree(rows) {
  const list = (rows || []).map(row => Object.assign({}, row))
  const map = {}
  list.forEach(row => { map[row.financeSubjectId] = row })
  const roots = []
  list.forEach(row => {
    const parent = row.parentId && map[row.parentId]
    if (parent && parent !== row) {
      if (!parent.children) parent.children = []
      parent.children.push(row)
    } else {
      roots.push(row)
    }
  })
  return roots
}

export default {
  name: 'FinanceSubject',
  mixins: [auth],
  components: { AddOrUpdate },
  data() {
    return {
      query: { subjectCode: '', subjectName: '', subjectType: '' },
      all: [],
      addOrUpdateVisible: false,
      typeOptions: [
        { value: '1', label: '资产' },
        { value: '2', label: '负债' },
        { value: '3', label: '权益' },
        { value: '4', label: '成本' },
        { value: '5', label: '损益' }
      ]
    }
  },
  computed: {
    shown() {
      const rows = this.all.filter(row => {
        if (this.query.subjectCode && String(row.subjectCode || '').indexOf(this.query.subjectCode) < 0) return false
        if (this.query.subjectName && String(row.subjectName || '').indexOf(this.query.subjectName) < 0) return false
        if (this.query.subjectType && String(row.subjectType) !== this.query.subjectType) return false
        return true
      })
      return toTree(rows)
    }
  },
  created() { this.load() },
  activated() { this.load() },
  methods: {
    typeLabel(val) {
      const item = this.typeOptions.find(o => o.value === String(val))
      return item ? item.label : val
    },
    load() {
      this.loading = true
      request.get('/finance/subject/list').then(res => {
        const data = res && res.data
        this.all = Array.isArray(data) ? data : ((data && data.list) || [])
      }).catch(() => { this.all = [] }).finally(() => { this.loading = false })
    },
    addOrUpdateHandle(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, !!readonly))
    }
  }
}
</script>

<style scoped>
.code-link { color: #348adb; cursor: pointer; }
</style>
